// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__fofLN","name":"ConsentHeader_name__2w5k4","birthday":"ConsentHeader_birthday__3LFC-","skeleton":"ConsentHeader_skeleton__1jUMq"};